module.exports = __webpack_public_path__ + "img/card_03@2x.1e86b9ef.png";